/* tslint:disable */
import {
  Account,
  IronAttachment,
  Project,
  TalentType,
  Worker,
  MilestoneLibrary
} from '../index';

declare var Object: any;
export interface RequestFormReceiptTemplateInterface {
  "sfdcId"?: string;
  "X3PL_Parts_Dispatch_Special_Instructions__c"?: string;
  "X3PL_Parts_Not_Required__c"?: boolean;
  "X3PS_Do_Not_Dispatch_FE__c"?: boolean;
  "Account__c"?: string;
  "Account_ID__c"?: string;
  "Account_Name__c"?: string;
  "Account_Selected__c"?: string;
  "Appointment_Call_or_Delay_Notes__c"?: string;
  "Appointment_Service_Visit_Type__c"?: string;
  "Appointment_Type__c"?: string;
  "Asset_Idntification__c"?: string;
  "Asset_Physical_Location__c"?: string;
  "Asset_Serial_Number__c"?: string;
  "Asset_Software_Revision__c"?: string;
  "Asset_Tag_Number__c"?: string;
  "Asset_Text__c"?: string;
  "B2B_Error__c"?: string;
  "B2B_Error_Occured__c"?: boolean;
  "B2B_Number_of_Files_Received__c"?: number;
  "B2B_Number_of_Messages_Received__c"?: number;
  "B2B_Order_Complete__c"?: boolean;
  "B2B_Submission__c"?: boolean;
  "Case_Activity_Type__c"?: string;
  "Case_Event_Priority_Level__c"?: string;
  "Case_Summary__c"?: string;
  "Cloned__c"?: boolean;
  "Clone_Task_Appointment_Options__c"?: string;
  "Customer_Appointment_Date_Time_Schedule__c"?: Date;
  "Customer_Appointment_Schedule_Start_Date__c"?: Date;
  "Customer_Appointment_Schedule_Start_Hour__c"?: string;
  "Customer_Appointment_Schedule_Start_Mi__c"?: string;
  "Type_Facebook_Ticket_Type__c"?: string;
  "Custom_work_order_instructions__c"?: string;
  "Description__c"?: string;
  "Earliest_Start_Date_Permitted__c"?: boolean;
  "Early_Start__c"?: Date;
  "Email_to_Case_Excel__c"?: boolean;
  "FRU_Quantity__c"?: number;
  "Iron_Attachments__c"?: string;
  "Is_FB_New_flow__c"?: boolean;
  "Is_MyWorkPlace__c"?: boolean;
  "Jobsite_City__c"?: string;
  "Jobsite_Company_End_User_or_Ship_To__c"?: string;
  "Jobsite_Contact_Email_End_User_or_Sh__c"?: string;
  "Jobsite_Contact_Name_End_User_or_Shi__c"?: string;
  "Jobsite_Contact_Phone_End_User__c"?: string;
  "Jobsite_Country__c"?: string;
  "Jobsite_Postal_Code__c"?: string;
  "Jobsite_State__c"?: string;
  "Jobsite_Street__c"?: string;
  "Maintenance_Event_Duration_PPM_Hours__c"?: string;
  "Model_Description__c"?: string;
  "Model_Number__c"?: string;
  "No_Of_Lines__c"?: number;
  "No_of_Master_Tasks__c"?: number;
  "OEM_RMA_Case_Number__c"?: string;
  "Partner_Case_Error_Description__c"?: string;
  "Partner_Case_Number__c"?: string;
  "PartnerCasePriority_B2BOK__c"?: string;
  "Partner_Case_Source__c"?: string;
  "PartnerCaseSummary_B2BOK__c"?: string;
  "PartnerCaseType_B2BOK__c"?: string;
  "Partner_FRU_Kit_Sku__c"?: string;
  "Partner_FRU_Sku__c"?: string;
  "PartnerJobSiteID_B2BOK__c"?: string;
  "PartnerMultipleSitesImpacted_B2B__c"?: string;
  "Partner_Site_ID__c"?: string;
  "Parts_Arrival_Date_Time_Requested__c"?: Date;
  "Parts_Delivery_Confirmation_Date_Time__c"?: Date;
  "Parts_Delivery_Date_Time_Scheduled_ETA__c"?: Date;
  "Parts_Requested_Arrival_Date__c"?: Date;
  "Parts_Requested_Arrival_DateTime__c"?: Date;
  "Parts_Requested_Arrival_Time_Hour__c"?: string;
  "Parts_Requested_Arrival_Time_Mi__c"?: string;
  "Parts_Ship_Confirmation_Date_Time_Shippd__c"?: Date;
  "PgMO_Milestone_Library__c"?: string;
  "Phone_Scheduling_1st_Attempt_Unreachable__c"?: Date;
  "Phone_Scheduling_2nd_Attempt_Unreachable__c"?: Date;
  "Phone_Scheduling_3rd_Attempt_Unreachable__c"?: Date;
  "PPE_Hours_Selected__c"?: string;
  "Program__c"?: string;
  "Rack__c"?: string;
  "Rack_Kit_Top_of_Switch__c"?: string;
  "Rack_Serial__c"?: string;
  "Rack_Side__c"?: string;
  "Rack_Sub_Position__c"?: string;
  "Rack_Sub_Position_Slot__c"?: string;
  "Request_Form_Type__c"?: string;
  "Row__c"?: string;
  "Service_Category_Type__c"?: string;
  "Service_Contract_Type__c"?: string;
  "Service_Coverage_Type__c"?: string;
  "Service_Dispatch_Priority__c"?: string;
  "Service_Engineer_Expertise_Level__c"?: string;
  "Service_Engineer_Talent_Type__c"?: string;
  "Serviceo_Case_Number__c"?: string;
  "Service_Profile_Selected__c"?: string;
  "Service_Type__c"?: string;
  "Short_URL__c"?: string;
  "Special_Instruction_for_Service_Engineer__c"?: string;
  "STLPC_Standard_Profile__c"?: string;
  "STLPC_Type__c"?: string;
  "Suite__c"?: string;
  "T_M_Standard_Price__c"?: number;
  "Vendor__c"?: string;
  "Worker__c"?: string;
  "Worker_Arrival_Date_Time_Actual__c"?: Date;
  "Worker_Arrival_Date_Time_Scheduled_ETA__c"?: Date;
  "Worker_Arrival_DateTime_Cust_Request__c"?: Date;
  "Worker_Arrival_DateTime_Cust_Requested__c"?: Date;
  "createdOnServiceo"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
  ironAttachment?: IronAttachment;
  project?: Project;
  talentType?: TalentType;
  accounts?: Account;
  worker?: Worker;
  milestoneLibrary?: MilestoneLibrary;
}

export class RequestFormReceiptTemplate implements RequestFormReceiptTemplateInterface {
  "sfdcId": string;
  "X3PL_Parts_Dispatch_Special_Instructions__c": string;
  "X3PL_Parts_Not_Required__c": boolean;
  "X3PS_Do_Not_Dispatch_FE__c": boolean;
  "Account__c": string;
  "Account_ID__c": string;
  "Account_Name__c": string;
  "Account_Selected__c": string;
  "Appointment_Call_or_Delay_Notes__c": string;
  "Appointment_Service_Visit_Type__c": string;
  "Appointment_Type__c": string;
  "Asset_Idntification__c": string;
  "Asset_Physical_Location__c": string;
  "Asset_Serial_Number__c": string;
  "Asset_Software_Revision__c": string;
  "Asset_Tag_Number__c": string;
  "Asset_Text__c": string;
  "B2B_Error__c": string;
  "B2B_Error_Occured__c": boolean;
  "B2B_Number_of_Files_Received__c": number;
  "B2B_Number_of_Messages_Received__c": number;
  "B2B_Order_Complete__c": boolean;
  "B2B_Submission__c": boolean;
  "Case_Activity_Type__c": string;
  "Case_Event_Priority_Level__c": string;
  "Case_Summary__c": string;
  "Cloned__c": boolean;
  "Clone_Task_Appointment_Options__c": string;
  "Customer_Appointment_Date_Time_Schedule__c": Date;
  "Customer_Appointment_Schedule_Start_Date__c": Date;
  "Customer_Appointment_Schedule_Start_Hour__c": string;
  "Customer_Appointment_Schedule_Start_Mi__c": string;
  "Type_Facebook_Ticket_Type__c": string;
  "Custom_work_order_instructions__c": string;
  "Description__c": string;
  "Earliest_Start_Date_Permitted__c": boolean;
  "Early_Start__c": Date;
  "Email_to_Case_Excel__c": boolean;
  "FRU_Quantity__c": number;
  "Iron_Attachments__c": string;
  "Is_FB_New_flow__c": boolean;
  "Is_MyWorkPlace__c": boolean;
  "Jobsite_City__c": string;
  "Jobsite_Company_End_User_or_Ship_To__c": string;
  "Jobsite_Contact_Email_End_User_or_Sh__c": string;
  "Jobsite_Contact_Name_End_User_or_Shi__c": string;
  "Jobsite_Contact_Phone_End_User__c": string;
  "Jobsite_Country__c": string;
  "Jobsite_Postal_Code__c": string;
  "Jobsite_State__c": string;
  "Jobsite_Street__c": string;
  "Maintenance_Event_Duration_PPM_Hours__c": string;
  "Model_Description__c": string;
  "Model_Number__c": string;
  "No_Of_Lines__c": number;
  "No_of_Master_Tasks__c": number;
  "OEM_RMA_Case_Number__c": string;
  "Partner_Case_Error_Description__c": string;
  "Partner_Case_Number__c": string;
  "PartnerCasePriority_B2BOK__c": string;
  "Partner_Case_Source__c": string;
  "PartnerCaseSummary_B2BOK__c": string;
  "PartnerCaseType_B2BOK__c": string;
  "Partner_FRU_Kit_Sku__c": string;
  "Partner_FRU_Sku__c": string;
  "PartnerJobSiteID_B2BOK__c": string;
  "PartnerMultipleSitesImpacted_B2B__c": string;
  "Partner_Site_ID__c": string;
  "Parts_Arrival_Date_Time_Requested__c": Date;
  "Parts_Delivery_Confirmation_Date_Time__c": Date;
  "Parts_Delivery_Date_Time_Scheduled_ETA__c": Date;
  "Parts_Requested_Arrival_Date__c": Date;
  "Parts_Requested_Arrival_DateTime__c": Date;
  "Parts_Requested_Arrival_Time_Hour__c": string;
  "Parts_Requested_Arrival_Time_Mi__c": string;
  "Parts_Ship_Confirmation_Date_Time_Shippd__c": Date;
  "PgMO_Milestone_Library__c": string;
  "Phone_Scheduling_1st_Attempt_Unreachable__c": Date;
  "Phone_Scheduling_2nd_Attempt_Unreachable__c": Date;
  "Phone_Scheduling_3rd_Attempt_Unreachable__c": Date;
  "PPE_Hours_Selected__c": string;
  "Program__c": string;
  "Rack__c": string;
  "Rack_Kit_Top_of_Switch__c": string;
  "Rack_Serial__c": string;
  "Rack_Side__c": string;
  "Rack_Sub_Position__c": string;
  "Rack_Sub_Position_Slot__c": string;
  "Request_Form_Type__c": string;
  "Row__c": string;
  "Service_Category_Type__c": string;
  "Service_Contract_Type__c": string;
  "Service_Coverage_Type__c": string;
  "Service_Dispatch_Priority__c": string;
  "Service_Engineer_Expertise_Level__c": string;
  "Service_Engineer_Talent_Type__c": string;
  "Serviceo_Case_Number__c": string;
  "Service_Profile_Selected__c": string;
  "Service_Type__c": string;
  "Short_URL__c": string;
  "Special_Instruction_for_Service_Engineer__c": string;
  "STLPC_Standard_Profile__c": string;
  "STLPC_Type__c": string;
  "Suite__c": string;
  "T_M_Standard_Price__c": number;
  "Vendor__c": string;
  "Worker__c": string;
  "Worker_Arrival_Date_Time_Actual__c": Date;
  "Worker_Arrival_Date_Time_Scheduled_ETA__c": Date;
  "Worker_Arrival_DateTime_Cust_Request__c": Date;
  "Worker_Arrival_DateTime_Cust_Requested__c": Date;
  "createdOnServiceo": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  ironAttachment: IronAttachment;
  project: Project;
  talentType: TalentType;
  accounts: Account;
  worker: Worker;
  milestoneLibrary: MilestoneLibrary;
  constructor(data?: RequestFormReceiptTemplateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RequestFormReceiptTemplate`.
   */
  public static getModelName() {
    return "RequestFormReceiptTemplate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RequestFormReceiptTemplate for dynamic purposes.
  **/
  public static factory(data: RequestFormReceiptTemplateInterface): RequestFormReceiptTemplate{
    return new RequestFormReceiptTemplate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RequestFormReceiptTemplate',
      plural: 'RequestFormReceiptTemplates',
      path: 'RequestFormReceiptTemplates',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "X3PL_Parts_Dispatch_Special_Instructions__c": {
          name: 'X3PL_Parts_Dispatch_Special_Instructions__c',
          type: 'string'
        },
        "X3PL_Parts_Not_Required__c": {
          name: 'X3PL_Parts_Not_Required__c',
          type: 'boolean'
        },
        "X3PS_Do_Not_Dispatch_FE__c": {
          name: 'X3PS_Do_Not_Dispatch_FE__c',
          type: 'boolean'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Account_ID__c": {
          name: 'Account_ID__c',
          type: 'string'
        },
        "Account_Name__c": {
          name: 'Account_Name__c',
          type: 'string'
        },
        "Account_Selected__c": {
          name: 'Account_Selected__c',
          type: 'string'
        },
        "Appointment_Call_or_Delay_Notes__c": {
          name: 'Appointment_Call_or_Delay_Notes__c',
          type: 'string'
        },
        "Appointment_Service_Visit_Type__c": {
          name: 'Appointment_Service_Visit_Type__c',
          type: 'string'
        },
        "Appointment_Type__c": {
          name: 'Appointment_Type__c',
          type: 'string'
        },
        "Asset_Idntification__c": {
          name: 'Asset_Idntification__c',
          type: 'string'
        },
        "Asset_Physical_Location__c": {
          name: 'Asset_Physical_Location__c',
          type: 'string'
        },
        "Asset_Serial_Number__c": {
          name: 'Asset_Serial_Number__c',
          type: 'string'
        },
        "Asset_Software_Revision__c": {
          name: 'Asset_Software_Revision__c',
          type: 'string'
        },
        "Asset_Tag_Number__c": {
          name: 'Asset_Tag_Number__c',
          type: 'string'
        },
        "Asset_Text__c": {
          name: 'Asset_Text__c',
          type: 'string'
        },
        "B2B_Error__c": {
          name: 'B2B_Error__c',
          type: 'string'
        },
        "B2B_Error_Occured__c": {
          name: 'B2B_Error_Occured__c',
          type: 'boolean'
        },
        "B2B_Number_of_Files_Received__c": {
          name: 'B2B_Number_of_Files_Received__c',
          type: 'number'
        },
        "B2B_Number_of_Messages_Received__c": {
          name: 'B2B_Number_of_Messages_Received__c',
          type: 'number'
        },
        "B2B_Order_Complete__c": {
          name: 'B2B_Order_Complete__c',
          type: 'boolean'
        },
        "B2B_Submission__c": {
          name: 'B2B_Submission__c',
          type: 'boolean'
        },
        "Case_Activity_Type__c": {
          name: 'Case_Activity_Type__c',
          type: 'string'
        },
        "Case_Event_Priority_Level__c": {
          name: 'Case_Event_Priority_Level__c',
          type: 'string'
        },
        "Case_Summary__c": {
          name: 'Case_Summary__c',
          type: 'string'
        },
        "Cloned__c": {
          name: 'Cloned__c',
          type: 'boolean'
        },
        "Clone_Task_Appointment_Options__c": {
          name: 'Clone_Task_Appointment_Options__c',
          type: 'string'
        },
        "Customer_Appointment_Date_Time_Schedule__c": {
          name: 'Customer_Appointment_Date_Time_Schedule__c',
          type: 'Date'
        },
        "Customer_Appointment_Schedule_Start_Date__c": {
          name: 'Customer_Appointment_Schedule_Start_Date__c',
          type: 'Date'
        },
        "Customer_Appointment_Schedule_Start_Hour__c": {
          name: 'Customer_Appointment_Schedule_Start_Hour__c',
          type: 'string'
        },
        "Customer_Appointment_Schedule_Start_Mi__c": {
          name: 'Customer_Appointment_Schedule_Start_Mi__c',
          type: 'string'
        },
        "Type_Facebook_Ticket_Type__c": {
          name: 'Type_Facebook_Ticket_Type__c',
          type: 'string'
        },
        "Custom_work_order_instructions__c": {
          name: 'Custom_work_order_instructions__c',
          type: 'string'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "Earliest_Start_Date_Permitted__c": {
          name: 'Earliest_Start_Date_Permitted__c',
          type: 'boolean'
        },
        "Early_Start__c": {
          name: 'Early_Start__c',
          type: 'Date'
        },
        "Email_to_Case_Excel__c": {
          name: 'Email_to_Case_Excel__c',
          type: 'boolean'
        },
        "FRU_Quantity__c": {
          name: 'FRU_Quantity__c',
          type: 'number'
        },
        "Iron_Attachments__c": {
          name: 'Iron_Attachments__c',
          type: 'string'
        },
        "Is_FB_New_flow__c": {
          name: 'Is_FB_New_flow__c',
          type: 'boolean'
        },
        "Is_MyWorkPlace__c": {
          name: 'Is_MyWorkPlace__c',
          type: 'boolean'
        },
        "Jobsite_City__c": {
          name: 'Jobsite_City__c',
          type: 'string'
        },
        "Jobsite_Company_End_User_or_Ship_To__c": {
          name: 'Jobsite_Company_End_User_or_Ship_To__c',
          type: 'string'
        },
        "Jobsite_Contact_Email_End_User_or_Sh__c": {
          name: 'Jobsite_Contact_Email_End_User_or_Sh__c',
          type: 'string'
        },
        "Jobsite_Contact_Name_End_User_or_Shi__c": {
          name: 'Jobsite_Contact_Name_End_User_or_Shi__c',
          type: 'string'
        },
        "Jobsite_Contact_Phone_End_User__c": {
          name: 'Jobsite_Contact_Phone_End_User__c',
          type: 'string'
        },
        "Jobsite_Country__c": {
          name: 'Jobsite_Country__c',
          type: 'string'
        },
        "Jobsite_Postal_Code__c": {
          name: 'Jobsite_Postal_Code__c',
          type: 'string'
        },
        "Jobsite_State__c": {
          name: 'Jobsite_State__c',
          type: 'string'
        },
        "Jobsite_Street__c": {
          name: 'Jobsite_Street__c',
          type: 'string'
        },
        "Maintenance_Event_Duration_PPM_Hours__c": {
          name: 'Maintenance_Event_Duration_PPM_Hours__c',
          type: 'string'
        },
        "Model_Description__c": {
          name: 'Model_Description__c',
          type: 'string'
        },
        "Model_Number__c": {
          name: 'Model_Number__c',
          type: 'string'
        },
        "No_Of_Lines__c": {
          name: 'No_Of_Lines__c',
          type: 'number'
        },
        "No_of_Master_Tasks__c": {
          name: 'No_of_Master_Tasks__c',
          type: 'number'
        },
        "OEM_RMA_Case_Number__c": {
          name: 'OEM_RMA_Case_Number__c',
          type: 'string'
        },
        "Partner_Case_Error_Description__c": {
          name: 'Partner_Case_Error_Description__c',
          type: 'string'
        },
        "Partner_Case_Number__c": {
          name: 'Partner_Case_Number__c',
          type: 'string'
        },
        "PartnerCasePriority_B2BOK__c": {
          name: 'PartnerCasePriority_B2BOK__c',
          type: 'string'
        },
        "Partner_Case_Source__c": {
          name: 'Partner_Case_Source__c',
          type: 'string'
        },
        "PartnerCaseSummary_B2BOK__c": {
          name: 'PartnerCaseSummary_B2BOK__c',
          type: 'string'
        },
        "PartnerCaseType_B2BOK__c": {
          name: 'PartnerCaseType_B2BOK__c',
          type: 'string'
        },
        "Partner_FRU_Kit_Sku__c": {
          name: 'Partner_FRU_Kit_Sku__c',
          type: 'string'
        },
        "Partner_FRU_Sku__c": {
          name: 'Partner_FRU_Sku__c',
          type: 'string'
        },
        "PartnerJobSiteID_B2BOK__c": {
          name: 'PartnerJobSiteID_B2BOK__c',
          type: 'string'
        },
        "PartnerMultipleSitesImpacted_B2B__c": {
          name: 'PartnerMultipleSitesImpacted_B2B__c',
          type: 'string'
        },
        "Partner_Site_ID__c": {
          name: 'Partner_Site_ID__c',
          type: 'string'
        },
        "Parts_Arrival_Date_Time_Requested__c": {
          name: 'Parts_Arrival_Date_Time_Requested__c',
          type: 'Date'
        },
        "Parts_Delivery_Confirmation_Date_Time__c": {
          name: 'Parts_Delivery_Confirmation_Date_Time__c',
          type: 'Date'
        },
        "Parts_Delivery_Date_Time_Scheduled_ETA__c": {
          name: 'Parts_Delivery_Date_Time_Scheduled_ETA__c',
          type: 'Date'
        },
        "Parts_Requested_Arrival_Date__c": {
          name: 'Parts_Requested_Arrival_Date__c',
          type: 'Date'
        },
        "Parts_Requested_Arrival_DateTime__c": {
          name: 'Parts_Requested_Arrival_DateTime__c',
          type: 'Date'
        },
        "Parts_Requested_Arrival_Time_Hour__c": {
          name: 'Parts_Requested_Arrival_Time_Hour__c',
          type: 'string'
        },
        "Parts_Requested_Arrival_Time_Mi__c": {
          name: 'Parts_Requested_Arrival_Time_Mi__c',
          type: 'string'
        },
        "Parts_Ship_Confirmation_Date_Time_Shippd__c": {
          name: 'Parts_Ship_Confirmation_Date_Time_Shippd__c',
          type: 'Date'
        },
        "PgMO_Milestone_Library__c": {
          name: 'PgMO_Milestone_Library__c',
          type: 'string'
        },
        "Phone_Scheduling_1st_Attempt_Unreachable__c": {
          name: 'Phone_Scheduling_1st_Attempt_Unreachable__c',
          type: 'Date'
        },
        "Phone_Scheduling_2nd_Attempt_Unreachable__c": {
          name: 'Phone_Scheduling_2nd_Attempt_Unreachable__c',
          type: 'Date'
        },
        "Phone_Scheduling_3rd_Attempt_Unreachable__c": {
          name: 'Phone_Scheduling_3rd_Attempt_Unreachable__c',
          type: 'Date'
        },
        "PPE_Hours_Selected__c": {
          name: 'PPE_Hours_Selected__c',
          type: 'string'
        },
        "Program__c": {
          name: 'Program__c',
          type: 'string'
        },
        "Rack__c": {
          name: 'Rack__c',
          type: 'string'
        },
        "Rack_Kit_Top_of_Switch__c": {
          name: 'Rack_Kit_Top_of_Switch__c',
          type: 'string'
        },
        "Rack_Serial__c": {
          name: 'Rack_Serial__c',
          type: 'string'
        },
        "Rack_Side__c": {
          name: 'Rack_Side__c',
          type: 'string'
        },
        "Rack_Sub_Position__c": {
          name: 'Rack_Sub_Position__c',
          type: 'string'
        },
        "Rack_Sub_Position_Slot__c": {
          name: 'Rack_Sub_Position_Slot__c',
          type: 'string'
        },
        "Request_Form_Type__c": {
          name: 'Request_Form_Type__c',
          type: 'string'
        },
        "Row__c": {
          name: 'Row__c',
          type: 'string'
        },
        "Service_Category_Type__c": {
          name: 'Service_Category_Type__c',
          type: 'string'
        },
        "Service_Contract_Type__c": {
          name: 'Service_Contract_Type__c',
          type: 'string'
        },
        "Service_Coverage_Type__c": {
          name: 'Service_Coverage_Type__c',
          type: 'string'
        },
        "Service_Dispatch_Priority__c": {
          name: 'Service_Dispatch_Priority__c',
          type: 'string'
        },
        "Service_Engineer_Expertise_Level__c": {
          name: 'Service_Engineer_Expertise_Level__c',
          type: 'string'
        },
        "Service_Engineer_Talent_Type__c": {
          name: 'Service_Engineer_Talent_Type__c',
          type: 'string'
        },
        "Serviceo_Case_Number__c": {
          name: 'Serviceo_Case_Number__c',
          type: 'string'
        },
        "Service_Profile_Selected__c": {
          name: 'Service_Profile_Selected__c',
          type: 'string'
        },
        "Service_Type__c": {
          name: 'Service_Type__c',
          type: 'string'
        },
        "Short_URL__c": {
          name: 'Short_URL__c',
          type: 'string'
        },
        "Special_Instruction_for_Service_Engineer__c": {
          name: 'Special_Instruction_for_Service_Engineer__c',
          type: 'string'
        },
        "STLPC_Standard_Profile__c": {
          name: 'STLPC_Standard_Profile__c',
          type: 'string'
        },
        "STLPC_Type__c": {
          name: 'STLPC_Type__c',
          type: 'string'
        },
        "Suite__c": {
          name: 'Suite__c',
          type: 'string'
        },
        "T_M_Standard_Price__c": {
          name: 'T_M_Standard_Price__c',
          type: 'number'
        },
        "Vendor__c": {
          name: 'Vendor__c',
          type: 'string'
        },
        "Worker__c": {
          name: 'Worker__c',
          type: 'string'
        },
        "Worker_Arrival_Date_Time_Actual__c": {
          name: 'Worker_Arrival_Date_Time_Actual__c',
          type: 'Date'
        },
        "Worker_Arrival_Date_Time_Scheduled_ETA__c": {
          name: 'Worker_Arrival_Date_Time_Scheduled_ETA__c',
          type: 'Date'
        },
        "Worker_Arrival_DateTime_Cust_Request__c": {
          name: 'Worker_Arrival_DateTime_Cust_Request__c',
          type: 'Date'
        },
        "Worker_Arrival_DateTime_Cust_Requested__c": {
          name: 'Worker_Arrival_DateTime_Cust_Requested__c',
          type: 'Date'
        },
        "createdOnServiceo": {
          name: 'createdOnServiceo',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'Account__c',
          keyTo: 'sfdcId'
        },
        ironAttachment: {
          name: 'ironAttachment',
          type: 'IronAttachment',
          model: 'IronAttachment',
          relationType: 'belongsTo',
                  keyFrom: 'Iron_Attachments__c',
          keyTo: 'sfdcId'
        },
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
                  keyFrom: 'Program__c',
          keyTo: 'sfdcId'
        },
        talentType: {
          name: 'talentType',
          type: 'TalentType',
          model: 'TalentType',
          relationType: 'belongsTo',
                  keyFrom: 'Service_Engineer_Talent_Type__c',
          keyTo: 'sfdcId'
        },
        accounts: {
          name: 'accounts',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'Vendor__c',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker',
          model: 'Worker',
          relationType: 'belongsTo',
                  keyFrom: 'Worker__c',
          keyTo: 'sfdcId'
        },
        milestoneLibrary: {
          name: 'milestoneLibrary',
          type: 'MilestoneLibrary',
          model: 'MilestoneLibrary',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Milestone_Library__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
